module.exports = __webpack_public_path__ + "img/ic_activity_share_blue.53e18c14.svg";